module.exports = __webpack_public_path__ + "img/ethan-post.3a30776b.jpg";